import { ArchiveRestore, Filter, LoaderCircle, MessageCirclePlus, Search } from "lucide-react";

import FiltersList from "./FiltersList";
import ConversationsList from "./ConversationsList";
import SearchResults from "./SearchResults";

/**
 * Coluna da esquerda: cabeçalho com arquivadas, filtros e nova conversa,
 * busca, "só não lidas" e a lista (ou os resultados da busca).
 */
const ConversationsSidebar = ({
  filters,
  updateFilters,
  showFilters,
  onToggleFilters,
  onNewConversation,
  archivedUnreadCount,
  users,
  tags,
  funnels,
  searching,
  searchResult,
  searchLoading,
  onOpenSearchResult,
  loading,
  conversations,
  pinnedIds,
  selectedChat,
  setSelectedChat,
  onLoadMore,
}) => (
  <div className="flex h-full w-80 flex-col border-r border-gray-200 bg-white transition-all duration-300 dark:border-gray-700 dark:bg-gray-800">
    <div className="border-b border-gray-200 p-4 dark:border-gray-700">
      <div className="mb-4 flex items-center justify-between">
        <h2 className="text-xl font-semibold text-gray-800 dark:text-gray-100">Conversas</h2>

        <div className="flex space-x-2">
          <button
            onClick={() => updateFilters("status", filters.status === "ARQUIVADO" ? "" : "ARQUIVADO")}
            className="relative rounded-lg p-2 transition-colors hover:bg-gray-100 dark:hover:bg-gray-700"
            aria-label="Abrir filtros"
            title="Mensagens Arquivadas"
          >
            <ArchiveRestore className="h-5 w-5 text-gray-600 dark:text-gray-300" />

            {archivedUnreadCount > 0 && (
              <span className="absolute -right-1 -top-1 flex h-5 min-w-[20px] items-center justify-center rounded-full bg-red-500 px-1.5 text-xs font-bold text-white">
                {archivedUnreadCount}
              </span>
            )}
          </button>

          <button
            onClick={onToggleFilters}
            className="rounded-lg p-2 transition-colors hover:bg-gray-100 dark:hover:bg-gray-700"
            aria-label="Abrir filtros"
            title="Filtros"
          >
            <Filter className="h-5 w-5 text-gray-600 dark:text-gray-300" />
          </button>

          <button
            onClick={onNewConversation}
            className="rounded-lg p-2 transition-colors hover:bg-gray-100 dark:hover:bg-gray-700"
            aria-label="Abrir contatos"
            title="Contatos"
          >
            <MessageCirclePlus className="h-5 w-5 text-gray-600 dark:text-gray-300" />
          </button>
        </div>
      </div>

      <div className="relative mb-4">
        <Search className="absolute left-3 top-3 h-4 w-4 text-gray-400 dark:text-gray-300" />

        <input
          type="text"
          placeholder="Buscar conversas..."
          className="w-full rounded-lg border border-gray-300 bg-white py-2 pl-10 pr-4 text-gray-900 placeholder-gray-400 outline-none transition-colors duration-200 focus:border-green-500 focus:ring-2 focus:ring-green-500 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-100 dark:placeholder-gray-400"
          value={filters.search}
          onChange={(e) => updateFilters("search", e.target.value)}
        />
      </div>

      {showFilters && (
        <FiltersList
          users={users}
          tags={tags}
          funnels={funnels}
          filters={filters}
          onChange={updateFilters}
        />
      )}

      <div className="flex items-center justify-between rounded-lg bg-gray-50 p-3 transition-colors dark:bg-gray-900/50">
        <label className="text-sm font-medium text-gray-900 dark:text-gray-100">
          Mostrar apenas não lidas
        </label>
        <button
          onClick={() => updateFilters("unread", !filters.unread)}
          className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none ${
            filters.unread ? "bg-green-500" : "bg-gray-300 dark:bg-gray-600"
          }`}
          role="switch"
          aria-checked={filters.unread}
        >
          <span
            className={`inline-block h-4 w-4 transform rounded-full bg-white shadow-lg transition-transform ${
              filters.unread ? "translate-x-6" : "translate-x-1"
            }`}
          />
        </button>
      </div>
    </div>

    {searching ? (
      <SearchResults result={searchResult} loading={searchLoading} onOpen={onOpenSearchResult} />
    ) : loading ? (
      <div className="p-4 text-center text-gray-500 dark:text-gray-400">
        <LoaderCircle className="mx-auto mb-2 h-8 w-8 animate-spin text-gray-300 dark:text-gray-600" />
        <p className="text-sm">Carregando Conversas</p>
      </div>
    ) : (
      <ConversationsList
        conversations={conversations}
        pinnedIds={pinnedIds}
        selectedChat={selectedChat}
        setSelectedChat={setSelectedChat}
        onLoadMore={onLoadMore}
      />
    )}
  </div>
);

export default ConversationsSidebar;
